import { componentProvider } from 'js-component-framework';
import NewsletterSignup from './newsletter-signup';
import './newsletter-signup.scss';

const newsletterSignupConfig = {
  name: 'newsletter-signup',
  component: NewsletterSignup,
};

componentProvider(newsletterSignupConfig);
